import { KeyboardDoubleArrowRight, DoneAll, MailOutline, PersonAddAlt1, Group } from '@mui/icons-material'
import { SvgIconProps } from '@mui/material/SvgIcon'
import React, { ComponentType } from "react"
import { Col } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import MediaQuery from "react-responsive"
import { Hr } from "./hr"

interface IFlowIconProps {
  icon: ComponentType<SvgIconProps>
  text: string
}

const FlowIcon = ({icon: Icon, text}: IFlowIconProps) => (
  <MediaQuery minDeviceWidth={768}>
    {(matches) =>
      matches ?
        <div className="rounded bg-light text-dark py-4" style={{width: "16%"}}>
          <Icon fontSize="large" />
          <p className="mb-0 mt-2">{text}</p>
        </div>
        :
        <div className="rounded bg-light text-dark py-2 px-1" style={{width: "16%"}}>
          <Icon fontSize="medium" />
          <p className="mb-0 mt-2" style={{fontSize: "10px"}}>{text}</p>
        </div>
    }
  </MediaQuery>
)

const FlowArrow = () => (
  <MediaQuery minDeviceWidth={768}>
    {(matches) =>
      matches ?
        <KeyboardDoubleArrowRight className="my-auto" fontSize="small" />
        :
        <KeyboardDoubleArrowRight className="my-auto" fontSize="small" />
    }
  </MediaQuery>
)


export const Flow: React.FC = () => {
  const { t } = useTranslation("translations", { keyPrefix: "EMPLOYMENT.FLOW" })
  return (
    <Col md="12" className="mt-3">
      <h3>{t("TITLE")}</h3>
      <Hr />
      <p className="mt-4">{t("DESC")}</p>
      <div className="my-4 d-flex justify-content-between">
        <FlowIcon icon={MailOutline} text={t("APPLY")} />
        <FlowArrow />
        <FlowIcon icon={DoneAll} text={t("DOCUMENT_SCREENING")} />
        <FlowArrow />
        <FlowIcon icon={Group} text={t("FIRST_INTERVIEW")} />
        <FlowArrow />
        <FlowIcon icon={PersonAddAlt1} text={t("ADOPTION")} />
      </div>
    </Col>
  )
}
